import Stripe from "stripe";
const stripe = new Stripe(process.env.STRIPE_SECRET_KEY as string, {
  apiVersion: "2020-08-27",
});
import { NextSeo } from "next-seo";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import DonationForm from "../components/donation-form";

interface IDonateProps {
  prices: any[];
}

export default function Donate({ prices }: IDonateProps) {
  return (
    <div>
      <NextSeo title="Donate" />
      <Navbar />
      <DonationForm prices={prices} />
      <Footer />
    </div>
  );
}

export async function getServerSideProps() {
  const isPreview = process.env.VERCEL_ENV === "preview";

  const prices = await stripe.prices.list({
    product:
      process.env.NODE_ENV === "production" && !isPreview
        ? "prod_MBFsFsHQ4G7AR4"
        : "prod_8aenfRi5CbtyYU",
    active: true,
  });

  return {
    props: {
      prices: prices.data.sort(
        (a: any, b: any) => a.unit_amount - b.unit_amount
      ),
    },
  };
}
